"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFood1 = function IconFood1(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M30 5h6.207l1.058 1.058L36.982 10h5.092l-2.143 30h-7.186A6.99 6.99 0 0 1 27 43H12a7 7 0 0 1-7-7v-1h29v1c0 .695-.101 1.366-.29 2h4.358l1.286-18h-7.87a10.97 10.97 0 0 1 2.512 6.706L34.014 28H5v-1c0-6.075 4.925-11 11-11h7q.18 0 .358.006L22.925 10H35.98l.255-3.558L35.793 6H30zm5.837 7H25.074l.307 4.259A11 11 0 0 1 30.548 19h4.787zm3.588 7 .5-7h-3.086l-.502 7zM23 18l.265.004a9 9 0 0 1 8.642 7.694l.037.302H7.055l.006-.05A9 9 0 0 1 16 18zm8.898 19-.01.059A5 5 0 0 1 27 41H12l-.217-.005a5 5 0 0 1-4.67-3.936L7.1 37zM8.871 30.645a2.13 2.13 0 0 1 2.23-.091l.146.09 1.32.88c.348.232.79.255 1.156.07l.12-.07 1.318-.879a2.13 2.13 0 0 1 2.229-.092l.146.09 1.333.882a1.13 1.13 0 0 0 1.146.068l.12-.07 1.326-.878a2.13 2.13 0 0 1 2.23-.091l.146.09 1.32.88c.348.232.79.255 1.153.072l.118-.069 1.293-.882a2.13 2.13 0 0 1 2.229-.092l.146.09 1.333.882a1.13 1.13 0 0 0 1.144.07l.118-.07.558.83a2.13 2.13 0 0 1-2.229.092l-.146-.09-1.333-.882a1.13 1.13 0 0 0-1.142-.07l-.117.068-1.295.883a2.15 2.15 0 0 1-2.237.09l-.147-.09-1.322-.881a1.13 1.13 0 0 0-1.146-.068l-.12.07-1.326.878a2.13 2.13 0 0 1-2.229.092l-.146-.09-1.333-.882a1.13 1.13 0 0 0-1.146-.069l-.118.07-1.32.88a2.15 2.15 0 0 1-2.237.09l-.147-.09-1.322-.881a1.13 1.13 0 0 0-1.147-.068l-.118.07-1.327.878a2.13 2.13 0 0 1-2.232.09l-.146-.09.558-.83a1.13 1.13 0 0 0 1.146.068l.12-.07z",
    clipRule: "evenodd"
  })));
};

export { IconFood1, IconFood1 as default };
